// Przycisk pakietu w cenniku (data-cc-plan): przed przewinięciem do formularza ustawia temat,
// który zawiera nazwę pakietu – np. „Pakiet Champion – 3500 zł”.
export function initPlanLinks() {
    document.addEventListener("click", (event) => {
        const link = event.target.closest("a[data-cc-plan]");
        if (!link || link.pathname !== window.location.pathname || !link.hash) {
            return;
        }
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        const select = (target || document).querySelector("select[name='cc_topic']");
        if (!select) {
            return;
        }
        const plan = link.dataset.ccPlan.toLocaleLowerCase("pl");
        const option = [...select.options].find((o) => o.text.toLocaleLowerCase("pl").includes(plan));
        if (option) {
            select.value = option.value;
        }
    });
}
